import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {ConfigService, initializeSentry, initializeJam} from '@q9elements/ui-kit/common';

import 'hammerjs';
import {hideFromWappalyzer} from './app/util/wappalyzer';

if (ConfigService.environment.production) {
  enableProdMode();
  initializeSentry();
  initializeJam();
}

if (ConfigService.environment.production) {
  console.log(`Version: ${environment.version}`);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(hideFromWappalyzer)
  .catch(err => console.log(err));
